import { createApp } from "vue";
// @ts-expect-error It isn't registering for some reason
import { RecycleScroller } from "vue-virtual-scroller";

import DebugPage from "../ui/DebugPage.vue";
import "vue-multiselect/dist/vue-multiselect.css";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

createApp(DebugPage)
    .component("RecycleScroller", RecycleScroller)
    .mount("#app");
